import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO: relay to reset the edited params to be empty
 */
export const discardParams = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.discardParams.relay(forwardTo =>
      rxjs.of(
        forwardTo(plugin.editedParams.actions.writeAllProperties, {
          input: { values: {} },
        }),
      ),
    ).asObservable,
)
